module.exports = __webpack_public_path__ + "static/media/kerry-logo.ddc895d3.svg";